import type { Role } from '~settings/api/lib/schemas';

export const RolesPriority: Record<Role, number> = {
  LABEL_ADMIN: 5,
  RELEASE_COORDINATOR: 6,
  VIDEO_COORDINATOR: 6,

  OPS_ADMIN: 3,
  TECH_ADMIN: 1,
  SUPPORT_ADMIN: 2,
  RELEASE_MANAGER: 4,
  VIDEO_MANAGER: 4,
};

export const sortByPriority = (roles: Role[]) =>
  [...roles].sort((a: Role, b: Role) => RolesPriority[a] - RolesPriority[b]);
